import type { AppIconProps } from "../IconTypes";

export const CloudIcon: React.FC<AppIconProps> = ({
  width,
  height,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width || "72"}
      height={height || "72"}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 54.012H19.971C12.255 54 6 47.979 6 40.551C6 33.126 12.255 27.105 19.971 27.105C21.15 21.819 25.353 17.505 30.996 15.786C36.636 14.07 42.864 15.207 47.328 18.786C51.792 22.356 53.814 27.807 52.638 33.093H55.608C57.5268 33.0949 59.4075 33.6285 61.0412 34.6347C62.675 35.6409 63.9979 37.0803 64.863 38.793M48 57H66M57 48V66"
        stroke="#7A909C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
